
import { defineComponent } from "vue";

const ADVISORY_BASE =
  "https://images.empoweredconsumerism-static-files.com/ovi/advisory";

const SESSION_KEY = "oviAdvisoryDismissed";

export default defineComponent({
  name: "ovi-advisory",
  data() {
    return {
      visible: false,
      isMobile: typeof window !== "undefined" ? window.innerWidth <= 450 : false,
      pcSlides: [
        {
          src: `${ADVISORY_BASE}/policy_activation_24hrs_PC.jpg`,
          alt: "Policy activation within 24 hours",
        },
        {
          src: `${ADVISORY_BASE}/over_65_years_old_PC.jpg`,
          alt: "Coverage for over 65 years old",
        },
        {
          src: `${ADVISORY_BASE}/read_your_insurance_policy_PC.jpg`,
          alt: "Read your insurance policy",
        },
        {
          src: `${ADVISORY_BASE}/repatcare_policy_signing_PC.jpg`,
          alt: "RepatCare policy signing",
        },
      ],
      mobileSlides: [
        {
          src: `${ADVISORY_BASE}/policy_activation_24hrs_MOBILE.jpg`,
          alt: "Policy activation within 24 hours",
        },
        {
          src: `${ADVISORY_BASE}/over_65_years_old_MOBILE.jpg`,
          alt: "Coverage for over 65 years old",
        },
        {
          src: `${ADVISORY_BASE}/read_your_insurance_policy_MOBILE.jpg`,
          alt: "Read your insurance policy",
        },
        {
          src: `${ADVISORY_BASE}/repatcare_policy_signing_MOBILE.jpg`,
          alt: "RepatCare policy signing",
        },
      ],
    };
  },
  computed: {
    slides(): { src: string; alt: string }[] {
      return this.isMobile ? this.mobileSlides : this.pcSlides;
    },
  },
  methods: {
    onResize() {
      this.isMobile = window.innerWidth <= 450;
    },
    close() {
      this.visible = false;
    },
    onClosed() {
      try {
        sessionStorage.setItem(SESSION_KEY, "1");
      } catch (e) {
        // ignore storage errors
      }
    },
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize);

    let dismissed = false;
    try {
      dismissed = sessionStorage.getItem(SESSION_KEY) === "1";
    } catch (e) {
      dismissed = false;
    }

    if (!dismissed) {
      this.$nextTick(() => {
        this.visible = true;
      });
    }
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.onResize);
  },
});
